import React, { useCallback, useEffect } from 'react';
import Header from '../../components/Header/Header';
import createDOMPurify from 'dompurify';
import useGetPageConfig from '../../hooks/useGetPageConfig';
import FAQMovioEN from './translations/en/FAQ.html';
import FaqFunBox from './translations/en/FaqFunbox.html';
import FaqEntertainu from './translations/en/FaqEntertainu.html';
import FaqFlixvid from './translations/en/FaqFlixvid.html';
import FaqMixstreamflix from './translations/en/FaqMixstreamflix.html';
import FaqSparkstream from './translations/en/FaqSparkstream.html';
import FaqID from './translations/id/Faq_ID.html';
import FaqBG from './translations/bg/Faq_bg.html';
import PageLoader from '../../components/Loaders/PageLoader';
import { config, getHostname } from '../../constants/domainConfig';
import { dashboardURL } from '../../constants/dashboardURL';

const sanitize = (html) => {
    if (!window) return '';
    return createDOMPurify(window).sanitize(html);
};

const getFAQTranslated = (product) => {
    switch (product) {
        case 'fun-box':
            return FaqFunBox;
        case 'entertainu':
            return FaqEntertainu;
        case 'flixvid':
            return FaqFlixvid;
        case 'mixstreamflix':
            return FaqMixstreamflix;
        case 'sparkstream':
            return FaqSparkstream;
        case 'nonton-tv':
            if (config.lang === 'id') {
                return FaqID;
            }
            return FAQMovioEN;
        case 'playnixzone':
            if (config.lang === 'bg') {
                return FaqBG;
            }
            return FAQMovioEN;
        default:
            return FAQMovioEN;
    }
};

const FAQ = () => {
    const [loading, setLoading] = React.useState(false);
    const [faqHTML, setFAQHTML] = React.useState('');
    const { product } = useGetPageConfig();

    const fetchHTML = useCallback(
        async (url) => {
            setLoading(true);
            try {
                const response = await fetch(url);
                if (response.ok) {
                    const html = await response.text();
                    setFAQHTML(html);
                } else {
                    console.warn(`Failed to fetch external FAQ from ${url} (status: ${response.status}). Falling back to local version.`);
                    setFAQHTML(getFAQTranslated(product)); // Fallback to local version if fetch fails
                }
            } catch (error) {
                console.error(`Error fetching external FAQ from ${url}:`, error);
                setFAQHTML(getFAQTranslated(product)); // Fallback to local version if fetch fails
            } finally {
                setLoading(false);
            }
        },
        [product],
    );

    useEffect(() => {
        const url = new URL(dashboardURL);
        url.searchParams.append('pageType', 'faq');
        url.searchParams.append('subdomain', getHostname());
        url.searchParams.append('language', 'en'); // Only English is available as of now
        fetchHTML(url);
    }, [fetchHTML, product]);

    if (loading) return <PageLoader />;

    return (
        <>
            <Header forceHideHamburger />
            <div className="static-pages">
                <div dangerouslySetInnerHTML={{ __html: sanitize(faqHTML) }} />
            </div>
        </>
    );
};

export default FAQ;
